import EditFormIndividual from "./EditFormIndividual";
export default EditFormIndividual;
